/* src/app/pages/refinamiento/pagorefinamientofinal/pagorefinamientofinal.component.scss */
/*# sourceMappingURL=pagorefinamientofinal.component.css.map */
